import http from '@/libs/http'

const user = {
  signin(credentials) {
    const user = {
      firstname: 'Oat',
      lastname: '3DS'
    }
    // fake call user api
    return new Promise((resolve, reject) => {
      if (credentials.password !== '123456') {
        setTimeout(() => {
          reject(new Error('Incorrect password.'))
        }, 1000)
      } else {
        setTimeout(() => {
          resolve(user)
        }, 1000)
      }
    })
  },
  login(credentials) {
    return http.post('/auth/cms/login', credentials).then(result => result.data).catch(error => error)
  },
  logout() {
    return http.post('/auth/cms/logout').then(result => result.data).catch(error => error)
  }
}

export default user
